// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vw_a bhk_b"};